import React from 'react';
import PropTypes from 'prop-types';
import ServerDOMLoader from './ServerDOMLoader';
import Loader from './Loader';
function Loaders(props) {
  if (props.isServerDOM) {
    return /*#__PURE__*/React.createElement(ServerDOMLoader, props);
  }
  return /*#__PURE__*/React.createElement(Loader, props);
}
Loaders.propTypes = {
  isServerDOM: PropTypes.bool
};
export default Loaders;
//# sourceMappingURL=Loaders.js.map